// DS: i6.19
import React from 'react';
import IconWrap from '../../IconWrap';
const AddImage = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.95 6a1 1 0 011 .95V7a.96.96 0 01-.8.99l-.13.01H4v13.75l3.16-3.27a1 1 0 011.32-.06l.09.08 3.12 3.23L6.75 27H9.5l8.85-9.44a1 1 0 01.63-.3l.12-.01a1 1 0 01.66.27l.08.08L25 23.72V14a1 1 0 112 0v14a1 1 0 01-1 1H3a1 1 0 01-1-1V7a1 1 0 011-1h15.95zM13 12a2 2 0 110 4 2 2 0 010-4zm13-9a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0V8h-2a1 1 0 110-2h2V4a1 1 0 011-1z",
        clipRule: "evenodd"
    })));
};
AddImage.displayName = 'AddImage';
export default AddImage;

//# sourceMappingURL=AddImage.js.map